import { createContext } from 'react';

export const LocalizationContext = createContext({
  resourceStrings: {},
  culture: 'en-US' // Defaulting to US
});

LocalizationContext.displayName = 'LocalizationContext';

export const withLocalization =
  (Component) =>
  ({ resourceStrings, culture, ...passThroughProps }) =>
    (
      <LocalizationContext.Provider value={{ resourceStrings, culture }}>
        <Component {...passThroughProps} />
      </LocalizationContext.Provider>
    );
